import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Sparkles, CheckCircle, AlertCircle, Mail, Bell } from 'lucide-react';

// Add font import
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate(); // Inicjalizacja hooka

  const subscribeViaWebhook = async (email) => {
    try {
      const response = await fetch('https://n8n.agencjasmart.marketing/webhook/szynkowski-newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          source: 'strona-szynkowski',
          timestamp: new Date().toISOString()
        })
      });
      if (!response.ok) throw new Error('Błąd podczas zapisu do newslettera');
      return await response.json();
    } catch (error) {
      console.error('Webhook Error:', error);
      throw error;
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus(null);
    setErrorMessage('');

    try {
      await subscribeViaWebhook(email);
      // Przekierowanie na stronę podziękowania po sukcesie
      navigate('/subskrypcja-potwierdzona');
    } catch (error) {
      setStatus('error');
      setErrorMessage(error.message || 'Coś poszło nie tak. Spróbuj ponownie.');
      setTimeout(() => {
        setStatus(null);
        setErrorMessage('');
      }, 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 md:py-24 relative overflow-hidden bg-black">
      <div className="absolute inset-0 opacity-10 z-0">
          <div className="absolute top-1/4 left-[20%] animate-float"><Mail className="w-24 h-24 text-violet-600/40" /></div>
          <div className="absolute bottom-1/4 right-[20%] animate-float animation-delay-2000"><Bell className="w-32 h-32 text-violet-600/40" /></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-2xl sm:text-3xl lg:text-5xl font-black text-white mb-4 uppercase leading-tight leading-tight" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}>
          Zasubskrybuj nasz newsletter
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 mb-8">
          I dowiedz się o nowych dofinansowaniach jako pierwszy
        </p>
        
        <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
          <input
            type="email"
            placeholder="Twój adres e-mail"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting}
            className="flex-1 min-w-0 px-5 sm:px-6 py-3.5 sm:py-4 bg-white/5 border border-white/10 rounded-full text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-violet-600 transition-all duration-300 disabled:opacity-50"
          />
          <button 
            type="submit" 
            disabled={isSubmitting}
            className="group flex items-center justify-center gap-2 px-6 sm:px-8 py-3.5 sm:py-4 bg-gradient-to-r from-violet-600 to-violet-700 text-white font-semibold rounded-full transition-all duration-300 hover:from-violet-700 hover:to-violet-800 hover:scale-105 disabled:opacity-50 disabled:hover:scale-100"
          >
            {isSubmitting ? (
              <>
                <div className="w-5 h-5 border-2 border-white/50 border-t-white rounded-full animate-spin"></div>
                <span>Zapisywanie...</span>
              </>
            ) : (
              <>
                <span>Zapisz się</span>
                <Sparkles className="w-5 h-5 group-hover:rotate-180 transition-transform duration-500" />
              </>
            )}
          </button>
        </form>

        {/* Komunikat błędu */}
        {status === 'error' && (
          <div className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-red-500/10 border border-red-500/20 rounded-full text-red-400 animate-slideInUp">
            <AlertCircle className="w-5 h-5" />
            <span>{errorMessage}</span>
          </div>
        )}
        
        <p className="text-sm text-gray-500 mt-8">
          Dołącz do 500+ przedsiębiorców otrzymujących ekskluzywne informacje o dotacjach
        </p>
      </div>

      <style>{`
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slideInUp { animation: slideInUp 0.3s ease-out forwards; }
        
        @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-20px) rotate(5deg); }
        }
        .animate-float {
            animation: float 8s ease-in-out infinite;
        }
        .animation-delay-2000 { animation-delay: 2s; }
      `}</style>
    </section>
  );
};

export default Newsletter;